import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { selectThemeMode } from 'app/modules/theme/selectors';
import { U21ComponentLibrary } from 'app/shared/u21-ui/components';
import { consoleError } from 'app/shared/utils/console';
import getFromProcessEnv from 'app/shared/utils/getFromProcessEnv';

interface Props {
  children: ReactNode;
}

const license = getFromProcessEnv('REACT_APP_MUI_X_LICENSE');

export const U21ComponentLibraryWrapper = ({ children }: Props) => {
  const themeMode = useSelector(selectThemeMode);
  return (
    <U21ComponentLibrary
      license={license}
      reportError={consoleError}
      mode={themeMode}
    >
      {children}
    </U21ComponentLibrary>
  );
};
